import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { EduNetInterface } from '../+models';

export const EDU_NET_SERVICE_TOKEN = new InjectionToken('EduNetService');

export interface EduNetServiceInterface {
  getAll(): Observable<EduNetInterface[]>;
  getEduNets$(
    searchTerm?: string,
    filters?: { [key: string]: string | number[] | number },
    pagination?: { from?: any; amount?: any },
    columns?: string[],
    sorting?: { [key: string]: 'asc' | 'desc' }
  ): Observable<{ results: EduNetInterface[]; count: number }>;
  deleteEduNetById(id: number): Observable<boolean>;
  create(eduNet: EduNetInterface): Observable<EduNetInterface>;
  update(eduNet: EduNetInterface): Observable<EduNetInterface>;
}
